import { useToast } from "../../context/ToastContext";

const STYLE = {
  info: { border: "border-purple-500", icon: "🚀" },
  success: { border: "border-emerald-500", icon: "✅" },
  warning: { border: "border-amber-500", icon: "⚠️" },
  error: { border: "border-red-500", icon: "⛔" },
} as const;

export function ToastHost() {
  const { toasts, dismiss } = useToast();
  return (
    <div className="pointer-events-none fixed bottom-4 end-4 z-[70] flex max-w-sm flex-col gap-2" role="region" aria-live="polite">
      {toasts.map((t) => (
        <button
          key={t.id}
          type="button"
          onClick={() => dismiss(t.id)}
          className={`pointer-events-auto flex items-center gap-2.5 rounded-2xl border-s-4 bg-cosmic-navy px-4 py-3 text-start text-xs font-black text-white shadow-2xl ${STYLE[t.kind].border}`}
        >
          <span aria-hidden>{STYLE[t.kind].icon}</span>
          <span>{t.message}</span>
        </button>
      ))}
    </div>
  );
}
